/* eslint-disable */

<template>
  <div class="navbar-container" style="z-index: 2000">
    <div :class="{ navbar_fan: !fan, navbar_fan_open: fan }">
      <div class="fan_empty"></div>
      <div class="fan_fill"></div>
      <div class="fan_empty"></div>
      <div class="fan_empty"></div>
    </div>
    <div id="myNav" :class="{ navbar_open: showNavbar, navbar: !showNavbar }">
      <div class="logo-nav">
        <img
          style="cursor: pointer"
          @click="redirectUser('/')"
          src="../assets/images/ChronoPress_OLD_HIghRes_white.png"
          alt="image1"
        />
        <div
          :class="{ burger_btn: true, black: !fan, cold_silver: fan }"
          v-if="testBool"
        >
          <tasty-burger-button
            :type="buttonType"
            :active="isActive"
            :color="color"
            :reversed="true"
            :active-color="activeColor"
            v-on:toggle="onToggle"
          />
        </div>
      </div>
      <div class="navbar-content">
        <b-nav-item @click="redirectUser('/')">
          {{ $t("navbar.home") }}
        </b-nav-item>
        <b-nav-item @click="redirectUser('/time_series')">
          {{ $t("home.service6") }}
        </b-nav-item>
        <b-nav-item @click="redirectUser('concordance')">
          {{ $t("home.service1") }}
        </b-nav-item>
        <b-nav-item @click="redirectUser('/maps')"> Mapy </b-nav-item>
        <b-nav-item @click="redirectUser('/word_profiles')">
          {{ $t("home.service3") }}
        </b-nav-item>
        <b-nav-item @click="redirectUser('/frequency_lists')">
          {{ $t("home.service2") }}
        </b-nav-item>
        <b-nav-item @click="redirectUser('/samples')">
          {{ $t("home.service7") }}
        </b-nav-item>

        <b-nav-item @click="redirectUser('/similarity')">
          Podobieństwo par
          <br />
          wyrazowych
        </b-nav-item>
      </div>
    </div>
  </div>
</template>

<script>
import { TastyBurgerButton } from "vue-tasty-burgers";

export default {
  name: "NavBar",
  components: {
    "tasty-burger-button": TastyBurgerButton,
  },
  data() {
    return {
      testBool: true,
      langs: ["pl", "en"],
      showNavbar: false,
      fan: false,
      changeLanguage: function (event) {
        this.$i18n.locale = event.toString();
        this.$forceUpdate();
      },
      buttonType: "elastic",
      isActive: false,
      color: "white",
      activeColor: "white",
    };
  },
  methods: {
    onToggle(active) {
      if (active) {
        this.openNavigation();
      } else {
        // This shouldnt be like that
        this.closeNavigation();
      }
    },
    redirectUser: function (path) {
      this.testBool = false;
      this.closeNavigation();
      this.$router.push(path);
      this.showHamburgerButton();
    },
    openNavigation: function () {
      this.fan = true;
      setTimeout(() => {
        this.showNavbar = !this.showNavbar;
      }, 500);
    },
    closeNavigation: function () {
      this.showNavbar = false;
      this.fan = false;
      setTimeout(() => {}, 500);
    },
    showHamburgerButton: function () {
      setTimeout(() => {
        this.testBool = true;
      }, 100);
    },
  },
  watch: {
    $route() {
      this.showHamburgerButton();
      this.testBool = true;
    },
  },
  watch: {
    $route() {
      setTimeout(() => {
        this.showHamburgerButton();
      }, 100);
    },
  },
  mounted() {
    this.showHamburgerButton();
  },
};
</script>

<style>
@import url("https://use.fontawesome.com/releases/v5.9.0/css/all.css");

.logo-nav {
  display: flex;
  height: 60px;
  width: 100%;
  background-color: transparent;
}
.logo-nav img {
  position: absolute;
  height: 60px;
  transform: translate(10%, 2%);
}
.burger_btn {
  display: flex;
  align-self: center;
  align-items: center;
  justify-content: center;
  height: 60px;
  width: 100vw;
  margin: 0;
  transition: 0.5s;
}
.black {
  background-color: var(--grey_black);
}
.cold_silver {
  background-color: var(--cold_silver);
}
#myNav {
  padding: 0;
  margin: 0;
}
.navbar-container {
  z-index: 99;
  height: 60px;
  position: fixed;
  left: 0;
  top: 0;
  width: 100%;
  padding: 0;
  margin: 0;
}
.navbar {
  z-index: 997;
  height: 60px;
  width: 100%;
  position: fixed;
  top: 0;
  left: 0;
  overflow-y: hidden !important;
  background-color: var(--grey_black);
  padding: 0 !important;
  margin: 0;
}
.navbar_open {
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-content: flex-start;
  align-items: flex-start;
  width: 100%;
  height: 100%;
  background-color: var(--cold_silver);
}
.navbar_fan {
  pointer-events: none;
  position: fixed;
  top: -200vw;
  left: -400vh;
  z-index: 1;
  display: block;
  width: 800vh;
  height: 400vw;
  transition: 0.5s;
  transform: rotate(0deg);
}
.navbar_fan_open {
  position: fixed;
  top: -200vw;
  left: -400vh;
  z-index: 1;
  display: block;
  width: 800vh;
  height: 400vw;
  transition: 0.5s;
  transform: rotate(90deg);
}
.fan_empty {
  pointer-events: none;
  width: 50%;
  height: 50%;
  position: relative;
  background-color: rgba(0, 0, 0, 0);
  float: left;
}
.fan_fill {
  width: 50%;
  height: 50%;
  position: relative;
  background-color: var(--cold_silver);
  float: left;
}
.navbar-content {
  overflow-y: auto;
  position: relative;
  width: 100%;
  text-align: center;
  margin-top: 5rem;
  margin-bottom: 2rem;
}
.navbar a,
.navbar_open a {
  padding: 8px;
  text-decoration: none;
  font-size: 24px;
  color: white;
  display: block;
  transition: 0.3s;
}
.navbar_open a:hover,
.navbar_open a:focus {
  color: var(--grey_black);
}
.navbar .closebtn,
.navbar_open .closebtn {
  position: absolute;
  top: 0px;
  left: 0px;
  color: white;
  cursor: pointer;
  width: 100%;
}

.openbtn {
  display: flex;
  justify-content: center;
  align-self: flex-start;
  align-items: center;
  align-content: center;
  background-color: var(--cold_silver);
  font-size: 35px;
  width: 100%;
  height: 60px;
  padding: 1rem;
  text-align: center;
}

@media screen and (max-height: 450px) {
  .navbar {
    overflow-y: auto;
  }
  .navbar_open a,
  .navbar a {
    font-size: 18px;
  }
  .navbar_open .closebtn {
    font-size: 35px;
    top: 15px;
    right: 35px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/NavBar.vue